// extracted by mini-css-extract-plugin
module.exports = {"appMobileTextBlockDesktop":"CreditPurposeAccordionModalForm_appMobileTextBlockDesktop__iS5nj"};